/** Helper dùng chung cho bảng Tài liệu (form + trang chi tiết). */

export const fileSize = (bytes) => {
  const n = Number(bytes);
  if (!n) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};

export const docIcon = (contentType = "") => {
  const t = contentType || "";
  if (t.includes("pdf")) return "bi-file-earmark-pdf";
  if (t.startsWith("image/")) return "bi-file-earmark-image";
  if (t.includes("sheet") || t.includes("excel")) return "bi-file-earmark-spreadsheet";
  if (t.includes("word") || t.includes("document")) return "bi-file-earmark-word";
  return "bi-file-earmark";
};

/** Hóa đơn doc-platform không có content_type -> luôn coi là PDF. */
export const documentIcon = (doc = {}) =>
  (doc.source === "doc_search" ? "bi-file-earmark-text" : doc.source === "erp_invoice" ? "bi-database" : docIcon(doc.content_type));

export const documentLabel = (doc = {}) =>
  doc.filename || doc.name || doc.inv_no || doc.vendor_name || doc.doc_platform_document_id || doc.document_id || "(untitled)";

export const formatDate = (v) => {
  if (!v) return "";
  const d = v instanceof Date ? v : new Date(v);
  return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleDateString("en-GB");
};
